/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateful
 */
import React, { PropTypes } from 'react';
import TimeRange from 'components/UI/Form/Fields/TimeRange'
import updateMultiLesson from 'controllers/lesson/updateMultiLesson'
import moment from 'moment'
import {fetchClassLesson} from 'containers/pages/ClassDetail//ducks'

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state={
      start_time: '',
      end_time: '',
      status: 'success',
      errorMessage: ''
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onChange(res){
    let start_time = moment(res.startTime, 'HH:mm').format('HH:mm:ss')
    let end_time = moment(res.endTime, 'HH:mm').format('HH:mm:ss')

    this.setState({start_time: start_time, end_time: end_time})
  }

  onSubmit(){
    const {classID, selected, dismiss, dispatch, proceed, pagination, state} = this.props
    const {start_time, end_time} = this.state
    let lesson_id_list = []
    selected.map((lesson) => {
      lesson_id_list.push(lesson.lesson_id)
    })

    updateMultiLesson(classID, {lesson_id_list, start_time, end_time, conflict_tag: 'allLessonNotAdd'})
    .then((res) => {
      if(res.result == 'failure' && res.reason == 'can not change time of lessons in the same date'){
        this.setState({status: 'error', errorMessage: __('Unable to change lesson time on the same date', 'lessonTable')})
      } else if (res.result == 'edit failed because of conflict'){
        this.setState({status: 'error', errorMessage: __('Conflict', 'lessonTable')})
      } else {
        dispatch(fetchClassLesson(classID, {
          amount_per_page: pagination.itemsCountPerPage,
          current_page_number: pagination.activePage,
          after_today: state
        }))
        proceed()
        // dismiss()
      }
    })
  }

  render() {
    const {dismiss} = this.props
    const {status, errorMessage} = this.state

    return (
      <div className='lesson-rest-time-content'>
        <div className='header text-center'>{__('Reset Lesson Time', 'lessonTable')}</div>
        <TimeRange onChange={this.onChange} />
        <div className={status}>{errorMessage}</div>
        <div className='text-center btn-wrapper'>
          <button className='btn btn-default' onClick={() => {dismiss()}}>{__('Cancel', 'lessonTable')}</button>
          <button className='btn btn-primary' onClick={this.onSubmit}>{__('Save', 'lessonTable')}</button>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/LessonEditTime/ModalContent.js